import React from 'react';

export const PermissionsContext = React.createContext<string[]>([]);

export const usePermissions = () => {
  const context = React.useContext(PermissionsContext);
  if (!context) {
    throw new Error('usePermissionsContext must be used within a PermissionsProvider');
  }
  return context;
};
